import React from "react";
import { useField, useFormikContext } from "formik";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

export default function MultiSelectField({ name, label, items = [] }) {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [field, meta] = useField(name);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setFieldValue(name, typeof value === "string" ? value.split(",") : value);
  };

  return (
    <FormControl
      fullWidth
      size="medium"
      error={meta.touched && Boolean(meta.error)}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={field.value || []}
        onChange={handleChange}
        onBlur={() => setFieldTouched(name, true)}
        renderValue={(selected) =>
          items
            .filter((item) => selected.includes(item.code))
            .map((item) => item.name)
            .join(", ")
        }
      >
        {items.map((item) => (
          <MenuItem key={item.code} value={item.code}>
            {/* <Checkbox checked={field.value?.includes(item.code)} />
            <ListItemText primary={item.name} /> */}
            {item.name}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{meta.touched && meta.error}</FormHelperText>
    </FormControl>
  );
}
